import React from 'react';
import { Comment, ContentType } from '../../types/content';
import CommentItem from './CommentItem';
import { useTheme } from '../../contexts/ThemeContext';

interface CommentListProps {
  comments: Comment[];
  contentType: ContentType;
  onLike: (commentId: string) => void;
  onReply: (commentId: string) => void;
}

export default function CommentList({ comments, contentType, onLike, onReply }: CommentListProps) {
  const { theme } = useTheme();

  // Group comments by parent to handle nested replies
  const groupedComments = comments.reduce((acc, comment) => {
    if (!comment.parentId) {
      if (!acc.root) acc.root = [];
      acc.root.push(comment);
    } else {
      if (!acc[comment.parentId]) acc[comment.parentId] = [];
      acc[comment.parentId].push(comment);
    }
    return acc;
  }, {} as Record<string, Comment[]>);

  const renderComments = (commentList: Comment[], level = 0) => {
    return commentList.map(comment => (
      <div key={comment.id} className={level > 0 ? 'ml-8' : ''}>
        <CommentItem
          comment={comment}
          contentType={contentType}
          onLike={() => onLike(comment.id)}
          onReply={() => onReply(comment.id)}
        />
        {groupedComments[comment.id] && level < 3 && (
          <div className="mt-2">
            {renderComments(groupedComments[comment.id], level + 1)}
          </div>
        )}
      </div>
    ));
  };

  return (
    <div className={`
      rounded-lg p-6 space-y-6
      ${theme === 'dark'
        ? 'bg-gray-800'
        : 'bg-white'
      }
    `}>
      <h3 className={`text-lg font-semibold ${
        theme === 'dark' ? 'text-gray-100' : 'text-gray-900'
      }`}>
        Comments ({comments.length})
      </h3>
      {groupedComments.root && renderComments(groupedComments.root)}
    </div>
  );
}